import React, { useEffect, useState } from 'react';
import { api } from '../services/homphyApi';

type Receipt = { id: number; receiptNumber: string; pdfUrl: string; receiptType?: string };

export default function ReceiptPage() {
  const id = window.location.pathname.split('/').pop();
  const [receipt, setReceipt] = useState<Receipt | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    void api.get<Receipt>(`/receipts/${id}`)
      .then(setReceipt)
      .catch((reason: Error) => setError(reason.message));
  }, [id]);

  if (error) return <div className="mx-auto max-w-xl p-8 text-red-600">{error}</div>;
  if (!receipt) return <div className="mx-auto max-w-xl p-8 text-slate-500">Loading receipt…</div>;

  const openPdf = (path: string) => {
    window.open(`${import.meta.env?.VITE_API_BASE_URL ?? '/api'}${path}`, '_blank', 'noopener,noreferrer');
  };
  return (
    <main className="mx-auto max-w-xl p-8">
      <h1 className="text-2xl font-black text-slate-900">Receipt {receipt.receiptNumber}</h1>
      <p className="mt-2 text-sm text-slate-600">{receipt.receiptType === 'SESSION' ? 'Your session receipt is ready. It confirms a session took place and does not confirm payment.' : 'Your payment documents are ready.'}</p>
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="rounded-xl bg-emerald-600 px-4 py-3 text-sm font-bold text-white" onClick={() => openPdf(receipt.pdfUrl)}>View receipt PDF</button>
      </div>
    </main>
  );
}
